import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";

export function UsersViewModel(logout) {
  const { showSuccess } = useToast();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState({
    data: [],
  });

  const getUsers = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`admin/users`, payload);
    setLoading(false);
    if (callResult.success) {
      const mappedUsers = callResult.data.data.map((user) => {
        return {
          ...user,
          typeText: user.type?.label || "Unknown",
        };
      });
      setUsers({ ...callResult.data, data: mappedUsers });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteUser = async function (userId) {
    let callResult = await makePostApiCall(`admin/deleteUser/${userId}`);

    if (callResult.success) {
      showSuccess(
        "User Deleted"
      );
      var newUsers = { ...users, data: users.data.filter((user) => user.id !== userId) };

      setUsers(newUsers);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    getUsers,
    loading,
    users,
    deleteUser,
  };
}
